export const TYPES_VIEW = [
    {
        label: 'По дням',
        value: 'day',
    },
    {
        label: 'По неделям',
        value: 'week'
    },
    {
        label: 'По месяцам',
        value: 'month'
    }
];

export const CALENDAR_VIEW = { value: 'month' };
